export function invalidTacticValidationParser(
  notificationDetails,
  parsedObject
) {
  if (!parsedObject) {
    parsedObject = {
      tacticName: null,
      errorType: 'TACTIC_VALIDATION',
    };
  }
  if (notificationDetails) {
    parsedObject.tacticName = notificationDetails.tacticName ?? null;
  }
  return parsedObject;
}
